import { VUE_APP_ENV } from '@pharmsnap/pharmsnap-web/config'
import { getLocaleLang } from './locale'

const isCnLang = getLocaleLang() === 'cn'
const globalTitle = isCnLang ? '全球新药竞争情报库' : 'Global Drug Intelligence Database'

export function createWebTitle(cnStr?: string, enStr?: string): string | undefined {
  return isCnLang ? cnStr : enStr
}
export function updateDocumentTitle(title: string = globalTitle) {
  const newTitle = [_norTitleDisplayAppEnv(VUE_APP_ENV), title].filter(Boolean).join(' ')
  document.title = `${newTitle} - ${globalTitle}`
}

function _norTitleDisplayAppEnv(appEnv: string) {
  if (appEnv.includes('prod')) {
    return ''
  }
  const longEnv2shotEnv: Record<string, string> = {
    release: 'rel',
    stage: 'sta',
  }
  const longEnvKeys = Object.keys(longEnv2shotEnv)
  for (const longEnvKey of longEnvKeys) {
    if (VUE_APP_ENV.includes(longEnvKey)) {
      appEnv = appEnv.replace(longEnvKey, longEnv2shotEnv[longEnvKey])
      break
    }
  }
  return appEnv.replaceAll('_', '-').toLocaleUpperCase()
}
